module.exports = __webpack_public_path__ + "static/media/smile-regular.817656c9.svg";